import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TrashIcon } from '@blade/ui-kit'
import { DeleteWalletDialog } from '@root/features/wallet/delete-wallet/ui/desktop'

import { EditWalletPanelItem } from './edit-wallet-panel-item'

import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
}

export const EditWalletDelete: React.FC<Props> = ({ wallet }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const handleDeleteOpen = () => setOpen(true)

  return (
    <>
      <EditWalletPanelItem
        intent="error"
        icon={<TrashIcon size={16} />}
        title={t('wallet.delete_wallet')}
        onClick={handleDeleteOpen}
      />
      <DeleteWalletDialog open={open} onOpenChange={setOpen} wallet={wallet} />
    </>
  )
}
